import { AwakeService } from './awake.service';

export default angular
  .module('sfMobile.services.awake', ['sfMobile.services.platform'])
  .service('awakeFactory', AwakeService).name;
